<template>
	<div>
		<div v-if=" ptInitData.productInfo.KAIGYO_FLG == 1"
			class="itemNmContainer sort-item">
			<span class="dddddddddcatchCopyPre" v-html="ptInitData.productInfo.CATCH_COPY_PRE"></span>
			<br><span class="webItemNm">{{ ptInitData.productInfo.WEB_ITEM_NM }}</span>
			<br><span class="catchCopySuf" v-html="ptInitData.productInfo.CATCH_COPY_SUF"></span>
		</div>
		<div v-else-if="ptInitData.productInfo.KAIGYO_FLG != 1"
			class="itemNmContainer sort-item">
			<span class="catchCopyPre" v-html="ptInitData.productInfo.CATCH_COPY_PRE"></span>
			<span class="webItemNm">{{ ptInitData.productInfo.WEB_ITEM_NM }}</span>
			<span class="catchCopySuf" v-html="ptInitData.productInfo.CATCH_COPY_SUF"></span>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'itemNmContainer',
		props: {
			ptInitData: {
				type: Object,
				default: null,
			}
		},
	}
</script>